import { reduce } from "et3-type-guards";
import React from "react";
import i18n from "../../../constants/i18n";
import getUserAdvancedStore from "../../../stores/user-store/advanced-store";
import Et3Image from "../../et3-Image";
import Et3Button from "../../et3-button";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import { AccepRejectType, PictureAccepRejectType } from "../../../TypesNEW";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

const AcceptRejectedPicture = withLiteObserverAndTheme<AccepRejectType>(
  (props) => {
    const { currentImageID, noImageFound, currentIndex, imageName } = props;
    const userID = getUserAdvancedStore().currentUserId.get();
    const userUUID = reduce(
      () => getUserAdvancedStore().userData.get(userID).userUUID,
      ""
    );
    const userPictures = reduce(
      () => getUserAdvancedStore().userData.get(userID).pictures,
      []
    );
    const { profilePictureStatus, isPictureActive } =
      getUserAdvancedStore().getImageData(userPictures[currentIndex]);
    const isCurrentPictureActive =
      !noImageFound && profilePictureStatus !== "N" && isPictureActive;

    return (
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER_ALBUM_PICTURES")}
        imageName={imageName}
        size={55}
        onClick={() => {
          getUserAdvancedStore().imageAcceptRejectStatus(
            imageName,
            userID,
            userUUID,
            currentIndex,
            currentImageID
          );
        }}
        style={{
          opacity: isCurrentPictureActive ? 1 : 0.5,
          borderRadius: 10,
          cursor: "pointer"
        }}
      />
    );
  }
);

const PictureAcceptReject = withLiteObserverAndTheme<PictureAccepRejectType>(
  (props) => {
    const { currentImageID, noImageFound, currentIndex, theme } = props;
    const { colors } = theme;
    const isUserDeleted = getUserAdvancedStore().isUserStatusDeleted.get();
    const userID = getUserAdvancedStore().currentUserId.get();
    const userUUID = reduce(
      () => getUserAdvancedStore().userData.get(userID).userUUID,
      ""
    );
    const userPictures = reduce(
      () => getUserAdvancedStore().userData.get(userID).pictures,
      []
    );
    const profilePictureStatus =
      userPictures[currentIndex].profilePictureStatus;
    const ifProfilePictureStatusExist =
      profilePictureStatus === "Y" || profilePictureStatus === "N";
    const { isPictureActive } = getUserAdvancedStore().getImageData(
      userPictures[currentIndex]
    );
    const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
    const canChangeStatus =
      isPictureActive && !isUserDeleted && !isAnyKhattabaAdmin;

    return canChangeStatus ? (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={200}
        height={82}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {ifProfilePictureStatusExist ? (
          <Et3Button
            type="GET"
            isEnabled={true}
            onClick={async () => {
              await getUserAdvancedStore().imageChangeStatus(
                profilePictureStatus,
                userID,
                userUUID,
                currentIndex,
                currentImageID
              );
            }}
            size="MEDIUM"
            text="CHANGE_STATUS"
          />
        ) : (
          <React.Fragment>
            <AcceptRejectedPicture
              currentImageID={currentImageID}
              noImageFound={noImageFound}
              currentIndex={currentIndex}
              imageName={"rejected-logo"}
            />
            <AcceptRejectedPicture
              currentImageID={currentImageID}
              noImageFound={noImageFound}
              currentIndex={currentIndex}
              imageName={"accepted-logo"}
            />
          </React.Fragment>
        )}
      </ET3Div>
    ) : null;
  }
);
export default PictureAcceptReject;
